import { useState } from "react";
import axios from "axios";

/* ================= CONFIG ================= */
const API_BASE_URL = "https://avitaresidences.in/avita/api/v1";
// const API_BASE_URL = "http://localhost:8008/api/v1";
const PG_INITIATE_URL = "https://pgpay.icicibank.com/pg/api/v2/initiateSale";

/* ================= UTILS ================= */
const getTxnDate = () => {
    const now = new Date();
    return (
        now.getFullYear().toString() +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        now.getDate().toString().padStart(2, "0") +
        now.getHours().toString().padStart(2, "0") +
        now.getMinutes().toString().padStart(2, "0") +
        now.getSeconds().toString().padStart(2, "0")
    );
};

/* ================= API CALLS ================= */
const paymentOrderInitiate = async (payload) => {
    const res = await axios.post(`${API_BASE_URL}/order/initiate`, payload);
    return res.data;
};

const paymentGatewayInitiate = async (payload) => {
    const res = await axios.post(PG_INITIATE_URL, payload);
    return res.data;
};

const paymentOrderCreate = async (payload) => {
    const res = await axios.post(`${API_BASE_URL}/order/create`, payload);
    return res.data;
};

/* ================= APP ================= */
function App() {
    const [loading, setLoading] = useState(false);
    const [paymentUrl, setPaymentUrl] = useState("");

    const handlePayNow = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const amount = 1; // ₹100

            const payload = {
                userId: "695e1000cdd5482b91fb484f",
                pgId: "68bed1471f58cd9eab6b6a89",
                merchantId: "100000000371258",
                aggregatorID: "100000000371257",
                merchantTxnNo: getTxnDate(),
                amount: amount,
                currencyCode: "356",
                payType: "0",
                customerEmailID: "saravananarcot@yahoo.com",
                transactionType: "SALE",
                txnDate: getTxnDate(),
                returnURL: `${API_BASE_URL}/order/status`,
                customerMobileNo: "9384284845",
                addlParam1: "Single Payment",
                addlParam2: "test",
            };

            /* 2️⃣ Generate secure hash */
            const hashRes = await paymentOrderInitiate(payload);
            if (hashRes.statusCode !== 200) {
                throw new Error("Secure hash generation failed");
            }
            console.log('twwieywieoeo', hashRes)

            /* 3️⃣ Initiate payment gateway */
            // const pgRes = await paymentGatewayInitiate(payload);
            // console.log(pgRes)
            if (hashRes.message?.responseCode === "R1000") {
                /* 4️⃣ Save order */
                await paymentOrderCreate({
                    userId: "695e1000cdd5482b91fb484f",
                    pgId: "68bed1471f58cd9eab6b6a89",
                    amount: amount,
                    paymentFor: "Single Payment",
                    paymentData: hashRes.message,
                });

                const redirectUrl =
                    hashRes.message.redirectURI + "?tranCtx=" + hashRes.message.tranCtx;

                setPaymentUrl(redirectUrl);

                /* 5️⃣ Redirect user */
                window.location.href = redirectUrl;
            } else {
                alert("Payment initiation failed");
            }
        } catch (err) {
            console.error(err);
            alert("Payment failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 40 }}>
            <h2>ICICI Payment Gateway</h2>

            <button
                onClick={handlePayNow}
                disabled={loading}
                style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    cursor: "pointer",
                }}
            >
                {loading ? "Processing..." : "Pay ₹1"}
            </button>

            {paymentUrl && (
                <p style={{ marginTop: 20 }}>
                    Redirecting to payment gateway...
                </p>
            )}
        </div>
    );
}

export default App;
